/* image compressor */

const MAX_IMAGE_WIDTH = 400;
const COMPRESS_IMG_TYPE = 'image/jpeg';
const COMPRESS_IMG_QUALITY = 1;

/**
 * use img_url cb(error, compressed_base64)
 *
 * @param img_url
 * @param cb
 */
function handle(img_url, cb) {
    loadImage(img_url, function checkAndCompressImage(error, image_elem) {
        // error
        if (error) return cb(error);

        // image width no need compress
        if (image_elem.width <= MAX_IMAGE_WIDTH) return cb(null, img_url);

        // compress image to new base64
        cb(null, compressImage(image_elem));
    });
}

function loadImage(src, cb) {
    let img = new Image();
    img.onload = e => cb(null, e.target);
    img.onerror = () => cb(new Error('img load failed'));
    img.src = src;
}

function compressImage(image_elem) {
    let [compress_width, compress_height] = getCompressSize(image_elem.width, image_elem.height);

    let ctx = newCanvasContext(compress_width, compress_height);
        ctx.drawImage(image_elem, 0, 0, compress_width, compress_height);

    return ctx.canvas.toDataURL(COMPRESS_IMG_TYPE, COMPRESS_IMG_QUALITY);
}

function getCompressSize(img_w, img_h) {
    let img_ratio = img_h / img_w;
    return [MAX_IMAGE_WIDTH, MAX_IMAGE_WIDTH * img_ratio];
}

function newCanvasContext(width, height){
    let cvs = document.createElement('canvas');
    cvs.width = width;
    cvs.height = height;
    return cvs.getContext('2d');
}

export default {
    handle
}